module.exports = __webpack_public_path__ + "img/linked.9048cdf8.png";